<!-- Popup Modal -->
<section class="popup-answer">
    <div class="modal" id="answerModal" tabindex="-1" aria-hidden="true" data-bs-backdrop="static" data-bs-scroll="false">
        <div class="modal-dialog modal-sm modal-dialog-centered">
            <div class="modal-content pb-5">
                <!-- Header -->
                <div class="modal-header border-0 d-block position-relative">
                    <div class="position-absolute top-0 end-0" (click)="closePopup()">
                        <img class="cursor-pointer" [src]="commonImagePath +'close_btn_sidebar.webp'" alt="close" data-bs-dismiss="modal" aria-label="Close" loading="lazy">
                    </div>
                    <h5 class="modal-title mb-0 text-start">Post Answer</h5>
                </div>
                <!-- Body -->
                <div class="modal-body">
                    <!-- Product Info -->
                    <div class="d-flex align-items-start gap-2  info-wrapper pb-3 border-bottom">
                        <img src="assets/images/karl-Kustum/product_engine_img.png" alt="product" class="review-thumb" loading="lazy">
                        <div class="flex-grow-1">
                            <div class="product-name fw-semibold">
                                BluePrint Engines Pro Series Chevy 502 C.I.D. 627 HP Dressed Long Block Crate Engines PS502CTC
                            </div>
                        </div>
                    </div>
                    <!-- Question Section -->
                    <div class="question-box  rounded">
                        <div class="question-meta ">
                            <strong>Jon Doe</strong> · Answered 10 Days ago
                        </div>
                        <div class="question-text">
                            Question asked would go here - Question asked would go here.
                        </div>
                    </div>
                    <!-- Answer Section -->
                    <div class="answer-box  rounded">
                        <div class="answer-meta ">
                            <strong>Rob Doe</strong> · Answered 12 Days ago
                        </div>
                        <div class="answer-text">
                            Last answer entry would go here. Last answer entry would go here. Last answer entry would go here.
                        </div>
                    </div>
                    <!-- Answer Input -->
                    <div class="answer-input">
                        <label for="answerText" class="form-label fw-bold"> Answer:</label>
                        <textarea id="answerText" class="form-control" rows="6" placeholder=""></textarea>
                    </div>
                </div>
                <!-- Footer -->
                <div class="modal-footer pt-3">
                    <button type="button" class="btn btn-post">Post Answer</button>
                </div>
            </div>
        </div>
    </div>
</section>